import { createContext, SetStateAction, Dispatch } from "react";
import { GenerateAPQuotationServiceRequest, SelectOption } from "../../../../../../../../shared/interfaces";

interface WizardDataFormContextProps {

    /** List of differents ranges of age */
    ageRangeList:                       Array<SelectOption>;

    /** Flag for identifiy if the list of age range is loading */
    isLoadingAgeRangeList:              boolean;

    /** List of differents relationships */
    relationshipList:                   Array<SelectOption>;

    /** Flag for identifiy if the list of relationships is loading */
    isLoadingRelationshipList:          boolean;

    /** Variable to save all info about AP quotation request, for generate quotation or requotations */
    quotationForm:                      GenerateAPQuotationServiceRequest | undefined;
    setQuotationForm:                   Dispatch<SetStateAction<GenerateAPQuotationServiceRequest | undefined>>

    //* Methods
    
    /** Method for get age range list */
    getAgeRangeListPerProduct:          ( article: string, branch: string, producto: string ) => Promise<void>;

    /** Method for get relationships list per product */
    getRelationshipsListPerProduct:     ( article: string, branch: string, product: string ) => Promise<void>;

    /** Methods for get description by id of an element of each list */
    getRelationshipDescriptionById:     (id: string) => string | undefined;
    getAgeRangeDescriptionById:         (id: string) => string | undefined;
    getAgeRangeMinMaxById:               (id: string) => { edadMinima: string; edadMaxima: string } | undefined;

    /** Method to refresh payment plans by vigency dates */
    getPaymentMethodPerVigency:         (article: string, vigencyFrom: string, vigencyTo: string) => Promise<void>;
}

export const WizardDataFormContext = createContext({} as WizardDataFormContextProps);